/*
 * Remove an element from the page. Supports cdn-settings objects.
 */
import Polyfills from '../polyfills';

export default (obj, type = 'script') => {
    let attr = { script: 'src', link: 'href' }[type] || 'src';
    try {
        Polyfills.remove[0].value.call(((obj.nodeType === 1 || obj.nodeType == 11 ? obj : document.querySelector(`${type}[${attr}="${obj[attr]}"]`))));
    } catch { }

    return true; // Always return true since the element must not have existed anyway.
}
